import { useLocation } from "react-router-dom";
import ConsultantChat from "@/components/ConsultantChat";
import { MessageSquareText, Image as ImageIcon, UserRound, Sparkles } from "lucide-react";

const STEPS = [
  { icon: MessageSquareText, title: "Conte sua ideia", desc: "Pra quem é o uniforme, quantas peças, cores e onde vai o logo." },
  { icon: ImageIcon, title: "Veja uma amostra", desc: "O consultor gera um mockup visual do seu uniforme em segundos." },
  { icon: UserRound, title: "Vendedor retorna", desc: "Um especialista da ATP envia valores e prazos pelo WhatsApp." },
];

export default function PublicOrcamento() {
  const loc = useLocation();
  const preProduct = new URLSearchParams(loc.search).get("produto") || "";
  const initialText = preProduct ? `Olá! Quero um orçamento de ${preProduct}.` : "";

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <div className="grid lg:grid-cols-[1fr_340px] gap-8 items-start">
        <section className="order-2 lg:order-1 rounded-2xl border border-[#1E293B] bg-[#0B0F17] overflow-hidden flex flex-col h-[70dvh] min-h-[460px]" data-testid="orcamento-chat-card">
          <div className="h-16 px-5 flex items-center justify-between border-b border-[#1E293B]">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#0CDBF2] flex items-center justify-center"><Sparkles size={18} className="text-[#07090E]" /></div>
              <div>
                <div className="font-heading font-semibold leading-tight">Consultor ATP</div>
                <div className="text-[11px] text-emerald-400 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-emerald-400" /> Online · responde em segundos</div>
              </div>
            </div>
            <div className="hidden sm:block text-xs font-mono uppercase tracking-widest text-[#0CDBF2]">Orçamento</div>
          </div>
          <div className="flex-1 min-h-0"><ConsultantChat initialText={initialText} /></div>
        </section>

        <aside className="order-1 lg:order-2 space-y-6 lg:sticky lg:top-24">
          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-[#0CDBF2] mb-3">Como funciona</div>
            <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight leading-tight">Seu orçamento começa com uma conversa.</h1>
            <p className="text-slate-400 mt-3 text-sm leading-relaxed">Sem formulário. Fale com o nosso consultor virtual, veja uma amostra do seu uniforme e receba a proposta de um vendedor humano.</p>
          </div>
          <ol className="space-y-4">
            {STEPS.map((s, i) => (
              <li key={s.title} className="flex gap-4" data-testid={`orcamento-step-${i}`}>
                <div className="w-10 h-10 shrink-0 rounded-lg bg-[#0CDBF2]/10 border border-[#0CDBF2]/30 flex items-center justify-center text-[#0CDBF2]"><s.icon size={18} /></div>
                <div>
                  <div className="font-semibold text-sm">{i + 1}. {s.title}</div>
                  <div className="text-slate-400 text-sm mt-0.5">{s.desc}</div>
                </div>
              </li>
            ))}
          </ol>
          <div className="text-xs text-slate-500 border-t border-[#1E293B] pt-4">Pedido mínimo: 15 peças por modelo. Valores e prazos são informados apenas pelo vendedor.</div>
        </aside>
      </div>
    </div>
  );
}
